import { useReferralsStatusQuery } from "@services/referrals/queries";

export const useReferralLink = () => {
  const { data: status } = useReferralsStatusQuery();

  return `${
    location.protocol + "//" + location.host
  }/signup/${status?.referralCode}`;
};
